import { useState } from "react";
import { C, Btn } from "../components/UI";

export default function Contato() {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    empresa: "",
    cargo: "",
    categoria: "",
    assunto: "",
    mensagem: ""
  });
  const [enviado, setEnviado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState("");

  const categorias = [
    "Dúvida sobre a plataforma",
    "Cadastrar empresa",
    "Parcerias",
    "Suporte",
    "Outros"
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setErro("");

    try {
      const response = await fetch("/api/contato", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setEnviado(true);
      } else {
        setErro(data.error || "Erro ao enviar mensagem. Tente novamente.");
      }
    } catch (error) {
      setErro("Erro ao enviar mensagem. Tente novamente.");
    } finally {
      setEnviando(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "14px 16px",
    fontSize: 15,
    border: `1px solid ${C.border}`,
    borderRadius: 10,
    background: "#fff",
    color: C.textMain,
    outline: "none",
    transition: "border-color 0.2s ease"
  };

  const labelStyle = {
    display: "block",
    fontSize: 14,
    fontWeight: 500,
    color: C.textMain,
    marginBottom: 8
  };

  if (enviado) {
    return (
      <div style={{ minHeight: "100vh", background: C.background }}>
        <section style={{ 
          maxWidth: 600,
          margin: "0 auto",
          padding: "120px 20px",
          textAlign: "center"
        }}>
          <div style={{ 
            background: C.surface,
            borderRadius: 20,
            padding: 48,
            border: `1px solid ${C.border}`
          }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✓</div>
            <h2 style={{ 
              fontFamily: "'Playfair Display', serif",
              fontSize: 28,
              fontWeight: 700,
              color: C.roseMid,
              marginBottom: 16
            }}>
              Mensagem enviada!
            </h2>
            <p style={{ fontSize: 16, color: C.textSec, marginBottom: 24 }}>
              Obrigada por entrar em contato. Responderemos em breve.
            </p>
            <Btn variant="primary" onClick={() => window.location.href = "/"}>
              Voltar para a home
            </Btn>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: C.background }}>
      
      {/* Hero */}
      <section style={{ 
        background: `linear-gradient(rgba(161, 69, 104, 0.85), rgba(161, 69, 104, 0.85)), url('/images/women-corporate.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "80px 20px",
        textAlign: "center"
      }}>
        <h1 style={{ 
          fontFamily: "'Playfair Display', serif",
          fontSize: 36,
          fontWeight: 700,
          color: "#fff",
          marginBottom: 16
        }}>
          Fale com a equipe WoMom
        </h1>
        <p style={{ 
          fontSize: 18,
          color: "rgba(255, 255, 255, 0.9)",
          maxWidth: 600,
          margin: "0 auto"
        }}>
          Estamos aqui para ajudar profissionais e empresas a construir ambientes de trabalho melhores.
        </p>
      </section>

      {/* Formulário */}
      <section style={{ 
        maxWidth: 700,
        margin: "-40px auto 60px",
        padding: "0 20px"
      }}>
        <div style={{ 
          background: C.surface,
          borderRadius: 20,
          padding: 40,
          border: `1px solid ${C.border}`,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
        }}>
          <form onSubmit={handleSubmit}>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 20, marginBottom: 20 }}>
              <div>
                <label style={labelStyle}>Nome *</label>
                <input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder="Seu nome"
                />
              </div>
              <div>
                <label style={labelStyle}>E-mail *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                  placeholder="seu@email.com"
                />
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 20, marginBottom: 20 }}>
              <div>
                <label style={labelStyle}>Empresa (opcional)</label>
                <input
                  type="text"
                  name="empresa"
                  value={formData.empresa}
                  onChange={handleChange}
                  style={inputStyle}
                  placeholder="Nome da empresa"
                />
              </div>
              <div>
                <label style={labelStyle}>Cargo (opcional)</label>
                <input
                  type="text"
                  name="cargo"
                  value={formData.cargo}
                  onChange={handleChange}
                  style={inputStyle}
                  placeholder="Seu cargo"
                />
              </div>
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>Categoria *</label>
              <select
                name="categoria"
                value={formData.categoria}
                onChange={handleChange}
                required
                style={{ ...inputStyle, cursor: "pointer" }}
              >
                <option value="">Selecione uma categoria</option>
                {categorias.map((cat) => (
                  <option key={cat} value={cat}>{cat}</option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>Assunto *</label>
              <input
                type="text"
                name="assunto"
                value={formData.assunto}
                onChange={handleChange}
                required
                style={inputStyle}
                placeholder="Assunto da mensagem"
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={labelStyle}>Mensagem *</label>
              <textarea
                name="mensagem"
                value={formData.mensagem}
                onChange={handleChange}
                required
                rows={5}
                style={{ ...inputStyle, resize: "vertical", minHeight: 120 }}
                placeholder="Escreva sua mensagem aqui..."
              />
            </div>

            {erro && (
              <div style={{ 
                background: "#FEE2E2", 
                color: "#DC2626", 
                padding: "12px 16px", 
                borderRadius: 8, 
                marginBottom: 20,
                fontSize: 14
              }}>
                {erro}
              </div>
            )}

            <Btn 
              type="submit" 
              variant="primary" 
              style={{ width: "100%", padding: "14px 24px", fontSize: 16, opacity: enviando ? 0.7 : 1 }}
              disabled={enviando}
            >
              {enviando ? "Enviando..." : "Enviar mensagem"}
            </Btn>
          </form>
        </div>
      </section>
    </div>
  );
}
